// import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { api } from 'src/api'
import { initialize } from 'src/api/initialize'
import 'mobx-react-lite/batchingForReactDom'
// import { Layout } from 'src/components/layout'

// const initialize =
//   typeof window !== 'undefined'
//     ? require('src/api/initialize').initialize
//     : undefined

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  // const [, page, projectID, state, step, subStep] = location.pathname.split('/')
  // const routeState = {
  //   page,
  //   params: { projectID },
  //   state: {
  //     name: step === 'summary' ? 'summary' : state,
  //     ...(step && step !== 'summary' && { step }),
  //     ...(subStep && { subStep }),
  //     ...location.state
  //   }
  // }
  // console.log(
  //   'gatsby-browser',
  //   location === prevLocation,
  //   location,
  //   prevLocation
  // )
  api.getState().setRouteState({
    location,
    prevLocation
    // ['*']: [state, step, subStep].join('/'),
    // projectID,
    // location,
    // side: state === 'editor' && step !== '' ? step : undefined
  })
}

export const onClientEntry = () => {
  require('typeface-roboto')
  // console.log(initialize)
  initialize()
  // initApi()
}

// export const wrapPageElement = ({ element, props }) => {
//   return <Layout>{element}</Layout>
// }

// export { wrapRootElement } from './gatsby/wrapRootElement'
export { wrapPageElement } from './gatsby/wrapPageElement'

export const replaceHydrateFunction = () => {
  return (element, container, callback) => {
    ReactDOM.unstable_createRoot(container, {
      hydrate: true,
      hydrationOptions: { onHydrated: callback }
    }).render(element)
  }
}
